module.exports = __webpack_public_path__ + "static/media/POWER_COLOUR.4b8a977c.png";